// MapController — the PIXI scene-layer Facade (map-architecture Phase 4).
//
// A plain TypeScript class (NOT React). Owns a single SceneManager instance and
// is the object MapCanvas talks to for scene lifecycle (mount/unmount).
//
// Shared mutable scene fields (markers, layers, analytics once-trackers, atlas,
// house-camera flag, mapEnterTs) live on MapSceneState — not bag-get/set pairs
// on this facade. SceneManager keeps the substantive PIXI lifecycle work.
import { SceneManager, type SceneManagerDeps } from './SceneManager';

export type MapControllerDeps = SceneManagerDeps;

export class MapController {
  private scene: SceneManager;

  constructor(deps: MapControllerDeps) {
    this.scene = new SceneManager(deps);
  }

  mount(canvasEl: HTMLDivElement | null): void {
    this.scene.mount(canvasEl);
  }

  unmount(): void {
    this.scene.unmount();
  }
}
